import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { createExchangeController } from './exchange-controller.js';
export function useConnectedExchanges(client, surface, t0) {
  const $ = _c(11);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== client.cacheKey || $[1] !== surface) {
    t1 = ["onramp", client.cacheKey, "exchange-capability", surface];
    $[0] = client.cacheKey;
    $[1] = surface;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== client || $[4] !== surface) {
    t2 = async t3 => {
      const {
        signal
      } = t3;
      const context = await client.getContext(signal, surface);
      return context.connectedExchanges ?? [];
    };
    $[3] = client;
    $[4] = surface;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      persist: false
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== enabled || $[8] !== t1 || $[9] !== t2) {
    t4 = {
      queryKey: t1,
      enabled,
      queryFn: t2,
      retry: false,
      staleTime: 60000,
      gcTime: 0,
      meta: t3
    };
    $[7] = enabled;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return useQuery(t4);
}
export function useExchangeCheckout(client, options) {
  const $ = _c(32);
  const {
    surface,
    locale,
    active,
    operationId,
    createId
  } = options;
  let t0;
  if ($[0] !== client || $[1] !== createId || $[2] !== locale || $[3] !== surface) {
    t0 = createExchangeController(client, surface, locale, createId);
    $[0] = client;
    $[1] = createId;
    $[2] = locale;
    $[3] = surface;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const actions = t0;
  const state = useSyncExternalStore(actions.subscribe, actions.getSnapshot, actions.getSnapshot);
  let t1;
  if ($[5] !== actions.dispose || $[6] !== client) {
    t1 = () => client.onDispose(actions.dispose);
    $[5] = actions.dispose;
    $[6] = client;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== actions || $[9] !== client) {
    t2 = [client, actions];
    $[8] = actions;
    $[9] = client;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[11] !== actions || $[12] !== operationId) {
    t3 = () => {
      if (operationId) {
        actions.resume(operationId);
      }
    };
    t4 = [actions, operationId];
    $[11] = actions;
    $[12] = operationId;
    $[13] = t3;
    $[14] = t4;
  } else {
    t3 = $[13];
    t4 = $[14];
  }
  useEffect(t3, t4);
  let t5;
  if ($[15] !== actions || $[16] !== active || $[17] !== state.operationId || $[18] !== state.screen || $[19] !== state.status?.status || $[20] !== state.submitted) {
    t5 = () => {
      if (!active || !state.operationId || !state.submitted && state.screen === "exchanges" || !["pending", "submission_unknown", "processing", "action_required"].includes(state.status?.status ?? "")) {
        return;
      }
      const timer = setInterval(() => void actions.refresh(), state.submitted ? 10000 : 2000);
      return () => clearInterval(timer);
    };
    $[15] = actions;
    $[16] = active;
    $[17] = state.operationId;
    $[18] = state.screen;
    $[19] = state.status?.status;
    $[20] = state.submitted;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = state.status?.status;
  let t7;
  if ($[22] !== actions || $[23] !== active || $[24] !== state.operationId || $[25] !== state.screen || $[26] !== state.submitted || $[27] !== t6) {
    t7 = [actions, active, state.operationId, state.screen, t6, state.submitted];
    $[22] = actions;
    $[23] = active;
    $[24] = state.operationId;
    $[25] = state.screen;
    $[26] = state.submitted;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  useEffect(t5, t7);
  let t8;
  if ($[29] !== actions || $[30] !== state) {
    t8 = {
      state,
      actions
    };
    $[29] = actions;
    $[30] = state;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
}